import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import workflowIcon from "@/assets/Icons/Workflow.png";
import repeatIcon from "@/assets/Icons/Repeat.png";
import connecterdIcon from "@/assets/Icons/Connected.png";
import cogwheelIcon from "@/assets/Icons/Cogwheel.png";
import IntegrationFlow from "@/components/IntegrationFlow";
import { AnimatedSection } from "@/components/AnimatedSection";
import heroBg from "@/assets/hero-bg-new.png";
const AIAutomation = () => {
  const {
    language
  } = useLanguage();
  const content = {
    is: {
      title: "FlæðiFulltrúi",
      subtitle: "Sjálfvirkni vinnuferla með gervigreind",
      description: "FlæðiFulltrúi sjálfvirknivæðir endurtekin verkefni og flókna vinnuferla svo starfsfólkið þitt geti einbeitt sér að mikilvægu verkefnunum.",
      features: [{
        icon: repeatIcon,
        title: "Endurteknar aðgerðir",
        description: "Sjálfvirknivæðir verkefni sem þarf að gera aftur og aftur án mannlegrar afskipta."
      }, {
        icon: connecterdIcon,
        title: "Samþætting kerfa",
        description: "Tengir saman mismunandi kerfi og forrit í eitt samfellt flæði og eykur framleiðni."
      }, {
        icon: cogwheelIcon,
        title: "Sérsniðin fyrir þitt fyrirtæki",
        description: "Búum til sérsniðnar lausnir sem henta nákvæmlega þínum vinnuferlum og þörfum."
      }]
    },
    en: {
      title: "AI Automation",
      subtitle: "Automate AIs with AI",
      description: "AI Automation automates repetitive tasks and complex AIs so your staff can focus on what matters most.",
      features: [{
        icon: repeatIcon,
        title: "Repetitive Actions",
        description: "Automates tasks that need to be done over and over without human intervention."
      }, {
        icon: connecterdIcon,
        title: "System Integration",
        description: "Connects different systems and applications into one seamless flow and increases productivity."
      }, {
        icon: cogwheelIcon,
        title: "Customized for Your Business",
        description: "We create tailored solutions that fit your exact work processes and needs."
      }]
    }
  };
  const t = content[language];
  return <main className="min-h-screen">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: `url(${heroBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-background/65 via-background/60 to-background" />
        </div>

        <div className="container px-6 md:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center animate-fade-in">
            <img
              src={workflowIcon}
              alt={t.title}
              className="h-32 w-32 mx-auto mb-6 object-contain"
              loading="lazy"
            />
            <h1 className="mb-6">{t.title}</h1>
            <p className="text-xl md:text-2xl text-muted-foreground mb-8">
              {t.subtitle}
            </p>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {t.description}
            </p>
          </div>
        </div>
      </section>

      {/* Integration Flow Section */}
      <AnimatedSection>
        <section className="py-20">
          <div className="container px-6 md:px-8">
            <div className="relative bg-transparent">
              <IntegrationFlow />
              {/* Optional edge fades to blend with background */}
              <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-background to-transparent" />
              <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-background to-transparent" />
            </div>
          </div>
        </section>
      </AnimatedSection>

      {/* Features Section */}
      <AnimatedSection delay={0.1}>
        <section className="py-20">
          <div className="container px-6 md:px-8">
            <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
              {t.features.map((feature, index) => (
                <div
                  key={index}
                  className="p-8 rounded-lg border border-border bg-card hover:shadow-lg transition-all animate-fade-in"
                  style={{
                    animationDelay: `${index * 0.1}s`
                  }}
                >
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="h-24 w-24 mb-4 object-contain"
                    loading="lazy"
                  />
                  <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
                  <p className="text-muted-foreground">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </AnimatedSection>

      <Footer />
    </main>;
};
export default AIAutomation;